import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Rocket14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_199)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.38382 1.55547L6.18928 3.75001H2.91415C1.35507 3.75001 0.574278 5.63501 1.67672 6.73745L2.78354 7.84427C1.61217 8.15951 0.75 9.22907 0.75 10.5V13.25H3.5C4.77094 13.25 5.84051 12.3878 6.15574 11.2165L7.2625 12.3232C8.36495 13.4257 10.2499 12.6449 10.2499 11.0858V7.81079L12.4445 5.61613C13.4268 4.63377 13.2499 3.26944 13.2499 2.00001C13.2499 1.30966 12.6903 0.750012 11.9999 0.750012C10.7305 0.750012 9.36618 0.573116 8.38382 1.55547ZM4.75 10.5C4.75 11.1904 4.19036 11.75 3.5 11.75H2.25V10.5C2.25 9.80966 2.80964 9.25001 3.5 9.25001C4.34131 9.25001 4.75 9.65388 4.75 10.5ZM6.5 9.43941L9.10609 6.83331L9.11606 6.82324L11.3838 4.55547C11.9543 3.98499 11.7499 2.97769 11.7499 2.25001C11.0223 2.25001 10.015 2.04565 9.44448 2.61613L4.56066 7.50007C4.88387 7.82328 5.20712 8.14647 5.53033 8.46968C5.85356 8.79291 6.17676 9.11618 6.5 9.43941ZM8.74994 9.31079L7.56066 10.5001L8.32316 11.2626C8.48065 11.4201 8.74994 11.3085 8.74994 11.0858V9.31079ZM4.68939 5.25001H2.91415C2.69143 5.25001 2.57988 5.5193 2.73738 5.67679L3.5 6.43941L4.68939 5.25001Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_199'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Rocket14.displayName = 'Rocket14';
export default Rocket14;
